export const HighlightedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    viewBox="0 0 150 150"
    {...props}
  >
    <defs>
      <style>{".st1{fill:#2e2e2e}"}</style>
    </defs>
    <path
      d="m78.82 3.15 8.55 1.43c20.41 4.69 36.76 21.37 41.05 41.87l1.26 8.16v6.47l-.93 6.52c-11.24 57.93-92.92 59.92-106.96 2.59l-1.43-8.55c.13-2.48-.17-5.13 0-7.59 1.9-26.78 24-49 50.87-50.9h7.59Z"
      className="st1"
    />
    <path
      d="M67.58 120.39 56.9 146.82c-.33.29-1.8-1.36-2.11-1.68-3.79-3.97-7.03-8.54-11.01-12.32l-19.19 1.06 10.96-26.71c9.38 7.01 20.25 12.03 32.03 13.22ZM114.51 107.17l10.68 26.71-18.91-1.07c-4.1 3.8-7.45 8.57-11.29 12.6-.3.31-1.47 1.66-1.83 1.4l-10.68-26.43c8.66-.92 17.02-3.88 24.53-8.21l7.5-5.01Z"
      className="st1"
    />
    <path
      d="m79.38 31.57 3.65 11.24a4.609 4.609 0 0 0 4.37 3.18h11.82c4.45 0 6.31 5.7 2.7 8.32l-9.56 6.95a4.594 4.594 0 0 0-1.67 5.14l3.65 11.24c1.38 4.24-3.47 7.76-7.08 5.14l-9.56-6.95a4.608 4.608 0 0 0-5.41 0l-9.56 6.95c-3.6 2.62-8.45-.9-7.08-5.14L59.3 66.4c.62-1.89-.06-3.97-1.67-5.14l-9.56-6.95c-3.6-2.62-1.75-8.32 2.7-8.32h11.82c1.99 0 3.76-1.28 4.37-3.18l3.65-11.24c1.38-4.24 7.37-4.24 8.75 0Z"
      style={{
        fill: "#bfbfbf",
      }}
    />
  </svg>
)